import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
 
import { Globals } from '../_Globals/globals'; 
 

import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'

@Injectable() 
export class AgencyService {
    public token: string;
 

    constructor(private http: Http, private globals: Globals) {
        // set token if saved in local storage
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.token = currentUser && currentUser.token;
    }

    getAgencies(page: Number, getParam: any[]): Observable<any> { 
        var param = 'search=';
        if(getParam != null) {
            param = this._buildParams(getParam);
        } 
        return this.http.get(this.globals.api_url + 'agencies/index/page:'+page+'?' + param)
            .map(data => {
            data.json(); 
                return data.json();
        });
    }

    getRepoAgencies(page: Number): Observable<any> { 
        return this.http.get(this.globals.api_url + 'agencies/index/repo/page:'+page)
            .map(data => {
            data.json(); 
                return data.json();
        });
    }

    addAgency(agency: any): Observable<any> {
        //console.log(agency);
        return this.http.post(this.globals.api_url + 'agencies/add', agency, { 
        }).map(data => {
                data.json();
                console.log(data.json());
                // the console.log(...) line prevents your code from working 
                // either remove it or add the line below (return ...)
                //console.log("I CAN SEE DATA HERE: ", data.json());
                return data.json();
        });
    } 

    addAgencyPic(agency: any, agency_id: any): Observable<any> {
        //console.log(agency);
        return this.http.post(this.globals.api_url + "agency_users/add?agency_id=" + agency_id, agency, { 
        }).map(data => {
                data.json();
                console.log(data.json());
                // the console.log(...) line prevents your code from working 
                // either remove it or add the line below (return ...)
                //console.log("I CAN SEE DATA HERE: ", data.json());
                return data.json();
        });
    } 

    addAgencyCeo(agency: any, agency_id: any): Observable<any> {
        console.log(this.globals.api_url + "agencies/edit/" + agency_id);
        return this.http.post(this.globals.api_url + "agencies/edit/" + agency_id, agency, { 
        }).map(data => {
                data.json();
                console.log(data.json());
                // the console.log(...) line prevents your code from working 
                // either remove it or add the line below (return ...)
                //console.log("I CAN SEE DATA HERE: ", data.json());
                return data.json();
        });
    }

    addAgencyUser(agency: any, agency_id: any): Observable<any> {
        //console.log(agency);
        return this.http.post(this.globals.api_url + "agency_users/add?agency_id=" + agency_id, agency, { 
        }).map(data => {
                data.json();
                console.log(data.json());
                // the console.log(...) line prevents your code from working 
                // either remove it or add the line below (return ...)
                //console.log("I CAN SEE DATA HERE: ", data.json());
                return data.json();
        });
    } 

    private _buildParams(params: any) {
        let urlSearchParams = new URLSearchParams();

        for(let key in params){
            if(params.hasOwnProperty(key)){
                urlSearchParams.append(key, params[key]);
            }
        }
        return urlSearchParams.toString();
    }

    private _rand(length, current) {
      current = current ? current : '';
      return length ? this._rand(--length, "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz".charAt(Math.floor(Math.random() * 60)) + current) : current;
    }
}


// WEBPACK FOOTER //
// ./src/app/_Services/agency.service.ts